import { defineMessages } from 'react-intl';

// ─────────────────────────────────────────────────────────────────────

export const accountMessages = defineMessages({
  dietaryRestrictionsTitle: {
    defaultMessage: 'Dietary restrictions',
    description: 'Account Screen | Dietary restrictions tab | Title',
  },
  notificationPreferencesTitle: {
    defaultMessage: 'Notifications',
    description: 'Account Screen | Notifications tab | Title',
  },
});
